export default __webpack_public_path__ + "./images/mir.50b149c4.svg";